export default "__VITE_ASSET__CbpvgD7g__"